module.exports = __webpack_public_path__ + "img/cloud2.ebfa84c2.png";